export enum SBAColumns {
    SummaryItemType = 'summaryItemType',
    OutstandingAmount = 'outstandingAmount',
    OutstandingNumber = 'outstandingNumber',
    BfiRepaysAmount = 'bfiRepaysAmount',
    BfiRepaysNumber = 'bfiRepaysNumber',
}
